import { Modal } from '@fuxi/eevee-ui';
import Compressor from 'compressorjs';

interface CompressImageProps {
  onOk: (file: File) => void;
  exceedMaxSize: () => void;
  onPreview?: (imageUrl: string) => void;
}

export function useCompressImage({ maxMB }) {
  const [modal] = Modal.useModal();
  const compressImage = (file: File, params: CompressImageProps) => {
    return new Promise((resolve, reject) => {
      new Compressor(file, {
        quality: 0.8,
        maxWidth: 1000,
        maxHeight: 1000,
        convertSize: 10000,
        convertTypes: ['image/png'],

        success(result: File) {
          if (result.size / 1024 / 1024 > maxMB) {
            modal.confirm({
              content: '图片过大，请重新选择',
              onOk: () => {
                params.exceedMaxSize();
              },
            });
            resolve(null);
          } else {
            const reader = new FileReader();
            reader.readAsDataURL(result);
            reader.onload = () => {
              params.onPreview && params.onPreview(reader.result as string);
            };

            params.onOk(result);
            resolve(result);
          }
        },
        error(err) {
          reject(err);
        },
      });
    });
  };
  const compressImageByWidthHeight = (
    file: File | Blob,
    params: { name: string; width: number; height: number; quality?: number },
  ): Promise<File> => {
    return new Promise((resolve, reject) => {
      new Compressor(file, {
        quality: params.quality ?? 0.8,
        maxWidth: params.width ?? 512,
        maxHeight: params.height ?? 512,

        success(result: Blob) {
          const imgFile = new File([result], params.name, {
            type: result.type,
          });
          resolve(imgFile);
        },
        error(err) {
          reject(err);
        },
      });
    });
  };
  return {
    compressImage,
    compressImageByWidthHeight,
  };
}
